import { Component, Input } from '@angular/core';
import { IMessengerConnector } from '../../../types/all.type';

@Component({
  selector: 'app-messages-last-date',
  templateUrl: './messages-last-date.component.html',
  styleUrls: ['./messages-last-date.component.css']
})
export class MessagesLastDateComponent {
  @Input() Service: IMessengerConnector;
  constructor() {}

}
